import {useSelector} from "react-redux";

import AppreciationTabInputText from "../../component/appreciation/AppreciationTabInputText";
import MissingDataIndicator from "../../component/MissingDataIndicator";
import {selectPersistenceInitialized} from "../../redux/persistenceSlice";
import {selectLoading, selectValueData, selectValueDataAvailable} from "../../redux/valueIndicationSlice";
import PersistenceFinalMessage from "../object/PersistenceFinalMessage";
import SnapshotMessage from "../object/SnapshotMessage";
import IndicationTable from "./IndicationTable";

export default function TabValueIndication() {
    const valueData = useSelector(selectValueData);
    const valueDataAvailable = useSelector(selectValueDataAvailable);
    const loading = useSelector(selectLoading);
    const persistenceInitialized = useSelector(selectPersistenceInitialized);

    return (
        <>
            <MissingDataIndicator dataAvailable={valueDataAvailable || loading || !persistenceInitialized} />
            <PersistenceFinalMessage />
            <SnapshotMessage />
            <AppreciationTabInputText page="value" tab="value" />
            <IndicationTable endpoint="VALUE" indicationDetails={valueData} />
        </>
    );
}
